/* These lines of code are defining constants in JavaScript using the `export const` syntax. */
export const PROCESSING_PAYMENT = 'PROCESSING_PAYMENT';
export const MAKE_PAYMENT_REQUEST = 'MAKE_PAYMENT_REQUEST';
export const MAKE_PAYMENT_SUCCESS = 'MAKE_PAYMENT_SUCCESS';
export const MAKE_PAYMENT_ERROR = 'MAKE_PAYMENT_ERROR';
export const GET_SHIPPING_ADDRESS_SUCCESS = 'GET_SHIPPING_ADDRESS_SUCCESS';
export const GET_SHIPPING_ADDRESS = 'GET_SHIPPING_ADDRESS';
